import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorPrestamosExternosCreditoComponent {
  idProyecto
  idColaborador
  agregando = false
  data = {
    deuda: null,
    credito: null,
    disponible: null
  }

  constructor($state, $q, ColaboradorPrestamosExternosCreditoService) {
    this.ColaboradorPrestamosExternos = ColaboradorPrestamosExternosCreditoService
    this.$q = $q
    this.$state = $state
  }

  $onInit() {
    this.promise = this.$q.all(
      this.ColaboradorPrestamosExternos.get(this.idProyecto, this.idColaborador)
        .then(({data}) => {
          this.data.credito = data.credito === null ? null: data.credito
          this.calcularMaximo()
        }),
      this.ColaboradorPrestamosExternos.getDeuda(this.idProyecto, this.idColaborador)
        .then(({data}) => {
          this.data.deuda = data.deuda
          this.calcularMaximo()
        })
    )
      .then(() => (this.calcularMaximo()))
  }

  actualizar(data) {
    this.data = data
  }

  agregar() {
    this.ColaboradorPrestamosExternos.post(this.idProyecto, this.idColaborador, this.data)
      .then(({data}) => {
        this.$state.go('empleado.configuracion')
      })
  }

  calcularMaximo() {
    this.data.disponible = this.data.credito - this.data.deuda
  }
}

module.component('colaboradorPrestamosExternosCredito', {
  controller: ColaboradorPrestamosExternosCreditoComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/prestamosExternos/credito/component.js